import { render, staticRenderFns } from "./params.vue?vue&type=template&id=1adbc38b&scoped=true"
import script from "./params.vue?vue&type=script&lang=ts"
export * from "./params.vue?vue&type=script&lang=ts"
import style0 from "./params.vue?vue&type=style&index=0&id=1adbc38b&prod&lang=scss"
import style1 from "./params.vue?vue&type=style&index=1&id=1adbc38b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adbc38b",
  null
  
)

export default component.exports